/**
 * Plugin to handle Supabase auth state changes and preserve redirect_to parameters
 * This is especially important for OAuth flows where the redirect_to parameter can be lost
 */

export default defineNuxtPlugin({
  name: 'auth-state-handler',
  enforce: 'pre', // Run before other plugins
  async setup() {
    const supabase = useSupabaseClient()
    
    // Only run on client-side
    if (import.meta.client) {
      // Set up auth state change listener
      const { data: { subscription } } = supabase.auth.onAuthStateChange(async (event, session) => {
        console.log('[DEBUG] Supabase auth state change:', event, session?.user?.email)
        
        // If we have a URL with code parameter (OAuth callback)
        if (window.location.href.includes('code=')) {
          // Check if we have a saved redirect_to in localStorage
          const savedRedirectTo = localStorage.getItem('mcp_redirect_to')
          
          if (savedRedirectTo && event === 'SIGNED_IN') {
            console.log('[DEBUG] Auth state handler - Found saved redirect_to:', savedRedirectTo)
            
            // Check if this is an MCP server redirect
            const { validateRedirectUrl } = useMcpRedirect()
            const validation = validateRedirectUrl(savedRedirectTo)
            
            if (validation.isValid && validation.sanitizedUrl) {
              console.log('[DEBUG] Auth state handler - Redirecting to MCP server:', validation.sanitizedUrl)
              
              // Clear the saved redirect_to
              localStorage.removeItem('mcp_redirect_to')
              
              // Redirect immediately to the MCP server
              window.location.href = validation.sanitizedUrl
              return
            } else {
              // Add the redirect_to parameter to the current URL for non-MCP redirects
              const currentUrl = new URL(window.location.href)
              currentUrl.searchParams.set('redirect_to', savedRedirectTo)
              
              // Update the URL without reloading the page
              // window.history.replaceState({}, '', currentUrl.toString())
              
              // Clear the saved redirect_to
              // localStorage.removeItem('mcp_redirect_to')
            }
          }
        }
      })
      
      // Clean up subscription on app unmount
      onUnmounted(() => {
        subscription.unsubscribe()
      })
    }
  }
})